import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { type ClientError } from 'graphql-request'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation AiSettingsPage_SetBrandAccountAiEnabled(
    $brandAccountId: ID!
    $aiEnabled: Boolean!
  ) {
    setBrandAccountAiEnabled(
      brandAccountId: $brandAccountId
      aiEnabled: $aiEnabled
    ) {
      id
      aiEnabled
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useSetBrandAccountAiEnabledMutation = (
  options: Omit<
    UseMutationOptions<Data, ClientError, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (variables) => graphQLRequest({ document, variables }),
    ...options,
  })
}
